var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "custom-select",
      attrs: { tabindex: _vm.tabindex },
      on: {
        blur: function ($event) {
          _vm.open = false
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "selected",
          class: { open: _vm.open },
          on: {
            click: function ($event) {
              _vm.open = !_vm.open
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.selected.title) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "items", class: { selectHide: !_vm.open } },
        _vm._l(_vm.options, function (option, i) {
          return _c(
            "div",
            {
              key: i,
              on: {
                click: function ($event) {
                  return _vm.doSelect(option)
                },
              },
            },
            [
              _c("span", { staticClass: "custom-select_title" }, [
                _vm._v(_vm._s(option.title)),
              ]),
              _vm._v(" "),
              _c("span", {
                staticClass: "custom-select_icon icon",
                class: option.icon,
              }),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }